import { FC } from 'react';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';
import { ButtonSkeleton } from '@/shared/components/skeletons';

import ColumnarListSkeleton from '../ColumnarListSkeleton';
import { WORKSPACE_RESOURCE_LIST_ACTIONS_WIDTH_REM, WORKSPACE_RESOURCE_LIST_COLUMN_COUNT } from './Skeleton';

interface WorkspaceResourceCollectionSkeletonProps {
    rowsPerSection?: number;
    sections?: number;
}

/** Grouped-list skeleton used by Archive, Trash, Drafts, and similar collection routes. */
const WorkspaceResourceCollectionSkeleton: FC<WorkspaceResourceCollectionSkeletonProps> = ({
    rowsPerSection = 3,
    sections = 3,
}) => {
    const { token } = useAntDesignTheme();

    return (
        <div
            aria-label='Loading workspace resource collection'
            role='status'
            style={{ height: '100%', overflow: 'hidden' }}
        >
            {Array.from({ length: sections }, (_value, sectionIndex) => (
                <section key={sectionIndex}>
                    <div
                        style={{
                            alignItems: 'center',
                            backgroundColor: token.colorBgBase,
                            borderBottom: `1px solid ${token.colorBorder}`,
                            display: 'flex',
                            gap: '0.5rem',
                            minHeight: '2rem',
                            padding: '0.25rem 1.5rem',
                        }}
                    >
                        <ButtonSkeleton
                            shape='square'
                            size='small'
                            style={{ height: '1rem', minWidth: '1rem', width: '1rem' }}
                        />
                        <ButtonSkeleton
                            block
                            size='small'
                            style={{ height: '0.75rem', width: sectionIndex % 2 === 0 ? '7rem' : '5rem' }}
                        />
                    </div>
                    <ColumnarListSkeleton
                        actionColumnWidthRem={WORKSPACE_RESOURCE_LIST_ACTIONS_WIDTH_REM}
                        ariaLabel={`Loading workspace resource section ${sectionIndex + 1}`}
                        columnCount={WORKSPACE_RESOURCE_LIST_COLUMN_COUNT}
                        includeHeader={false}
                        rows={rowsPerSection}
                        style={{ padding: '0 1rem' }}
                    />
                </section>
            ))}
        </div>
    );
};

export default WorkspaceResourceCollectionSkeleton;
